import * as React from "react";
import "./ShadowBox.scss";

export class ShadowBox extends React.Component<{}, {}> {
  public render() {
    return <div className={"ShadowBox"}>{this.props.children}</div>;
  }
}
